import { apiClient } from "@/config/api";
import {
  KKphimEpisode,
  CreateEpisodeDto,
  BulkCreateEpisodeDto,
  GetPaginationEpisodesDto,
  EpisodeListResponse,
} from "@/types/kkmovie";
import { ApiResponse } from "@/types/status";

const EPISODE_ENDPOINTS = {
  CREATE: "/kkphim-episodes",
  BULK_CREATE: "/kkphim-episodes/bulk",
  GET_ALL: "/kkphim-episodes",
  GET_BY_MOVIE: (kkmovieId: string) => `/kkphim-episodes/movie/${kkmovieId}`,
  GET_BY_ID: (episodeId: string) => `/kkphim-episodes/${episodeId}`,
  UPDATE: (episodeId: string) => `/kkphim-episodes/${episodeId}`,
  DELETE: (episodeId: string) => `/kkphim-episodes/${episodeId}`,
} as const;

export const kkphimEpisodeService = {
  // Tạo episode mới
  create: async (data: CreateEpisodeDto): Promise<ApiResponse<KKphimEpisode>> => {
    return await apiClient.post(EPISODE_ENDPOINTS.CREATE, data);
  },

  // Tạo nhiều episodes
  bulkCreate: async (data: BulkCreateEpisodeDto): Promise<ApiResponse<KKphimEpisode[]>> => {
    return await apiClient.post(EPISODE_ENDPOINTS.BULK_CREATE, data);
  },

  // Lấy danh sách episodes với phân trang
  getPaginationEpisodes: async (
    params: GetPaginationEpisodesDto
  ): Promise<ApiResponse<EpisodeListResponse>> => {
    return await apiClient.get(EPISODE_ENDPOINTS.GET_ALL, params as any);
  },

  // Lấy episodes của 1 movie
  getEpisodesByMovie: async (kkmovieId: string): Promise<ApiResponse<KKphimEpisode[]>> => {
    return await apiClient.get(EPISODE_ENDPOINTS.GET_BY_MOVIE(kkmovieId));
  },

  // Lấy episode theo ID
  getEpisodeById: async (episodeId: string): Promise<ApiResponse<KKphimEpisode>> => {
    return await apiClient.get(EPISODE_ENDPOINTS.GET_BY_ID(episodeId));
  },

  // Cập nhật episode
  updateEpisode: async (
    episodeId: string,
    data: Partial<CreateEpisodeDto>
  ): Promise<ApiResponse<KKphimEpisode>> => {
    return await apiClient.put(EPISODE_ENDPOINTS.UPDATE(episodeId), data);
  },

  // Xóa episode
  deleteEpisode: async (episodeId: string): Promise<ApiResponse<void>> => {
    return await apiClient.delete(EPISODE_ENDPOINTS.DELETE(episodeId));
  },
};
